import { LogisticsService } from '../../../services/logistics.service';
import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-study-report-delivery-observation-dialog',
  templateUrl: 'study-report-delivery-observation-dialog.component.html',
  styleUrls: ['./study-report-delivery-observation-dialog.component.css']
})

export class StudyReportDeliveryObservationDialogComponent implements OnInit {

  loading: boolean;
  form: FormGroup;
  constructor(private logisticsService: LogisticsService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<StudyReportDeliveryObservationDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: number) {
    this.form = this.formBuilder.group({
      UserFullName:  [{ value: '', disabled: true }],
      DeliveryObservation: [{ value: '', disabled: true }]
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async ngOnInit() {
    try {
      this.loading = true;
      const studyReportDeliveryObservation =
        await this.logisticsService.getStudyReportDeliveryObservation(this.data);
      this.form.patchValue({
        UserFullName: studyReportDeliveryObservation.UserFullName,
        DeliveryObservation: studyReportDeliveryObservation.DeliveryObservation
      });
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Observaciones de turno');
    } finally {
      this.loading = false;
    }
  }
}
